<template>
	<transition :name="invert?vertical?'fade-tab-vertical':'fade-tab-invert':vertical?'fade-tab-vertical-invert':'fade-tab'">
		<div
			v-if="$parent.tabBackgroundHidden"
			v-show="active"
			class="con-tab vs-tabs--content"
		>
			<slot />
		</div>
		<div
			v-else-if="active"
			class="con-tab vs-tabs--content"
		>
			<slot />
		</div>
	</transition>
</template>

<script>
export default {
	name: "VsPromptTabCustom",
	inheritAttrs: false,
	props: {
		label: {
			default: "Label",
			type: String,
		},
		icon: {
			default: "",
			type: String,
		},
		tag: {
			default: "",
			type: String,
		},
		iconPack: {
			type: String,
			default: "material-icons",
		},
		tabId: {
			default: "",
			type: String,
			required: true,
		},
	},
	data: () => ({
		vertical: false,
		active: false,
		id: null,
		invert: false,
	}),
	watch: {
		label(val) {
			this.$parent.tabChildren[this.id].label = val;
		},
		$attrs(val) {
			this.$parent.tabChildren[this.id].attrs = val;
		},
	},
	mounted() {
		console.log("tab add", this.tabId, this.id, this.$parent.tabChildrenKeys, this._uid);
		if (this.$parent.tabChildrenKeys[this.tabId] >= 0) {
			this.id = this.$parent.tabChildrenKeys[this.tabId];
			this.$parent.tabChildren[this.id] = {
				label: this.label,
				icon: this.icon,
				iconPack: this.iconPack,
				tag: this.tag,
				id: this.id,
				listeners: this.$listeners,
				attrs: this.$attrs,
				self: this,
			};
		} else {
			this.id = this.$parent.tabChildren.length;
			this.$parent.tabChildrenKeys[this.tabId] = this.id;
			this.$parent.tabChildren.push({
				label: this.label,
				icon: this.icon,
				iconPack: this.iconPack,
				tag: this.tag,
				id: this.id,
				listeners: this.$listeners,
				attrs: this.$attrs,
				self: this,
			});
		}
		console.log("tab add after", this.tabId, this.id, this.$parent.tabChildren[this.id].self._uid);
		/*console.log("tab add", this.tabId);
		this.id = this.tabId;
		this.$parent.tabChildren[this.id] = {
			label: this.label,
			icon: this.icon,
			iconPack: this.iconPack,
			tag: this.tag,
			id: this.id,
			listeners: this.$listeners,
			attrs: this.$attrs,
		};*/
	},
	beforeDestroy() {
		console.log("beforeDestroy TAB");
	},
};
</script>
